import { _API, _AXIOS_HELPER, _HEADER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    getListAndLatestDoneScheduleBySeqMedicalRelation( data ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/schedule/getListAndLatestDoneScheduleBySeqMedicalRelation';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },

    saveScheduleNoteBySeqSchedule( data ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/schedule/saveScheduleNoteBySeqSchedule';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },

    getAllScheduleByRangeForClinic( data ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/schedule/getAllScheduleByRangeForClinic';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },

    updateScheduleBySeqSchedule( data ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/schedule/updateNotStartedYetSchedule';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.PUT, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },

    insertScheduleBySeqMedicalRelation( data ) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/schedule/createSchedule';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },
    completeScheduleFromServer( data ) {
        return new Promise((resolve, reject) => {
            const url = _API + '/schedule/completeSchedule';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.PUT, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        });
    },

    cancelNotStartedYetSchedule(seqSchedule) {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/schedule/cancelNotStartedYetSchedule';
            const conf = {
                headers: _HEADER()
            };
            const data = { seqSchedule };
            _AXIOS_HELPER( ENUM.HTTP_METHOD.PUT, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },
    updateTimeline(data) {
        return new Promise(((resolve, reject) => {
            const url = _API + '/schedule/reservableTimeline/updateTimeline';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, data, conf)
                .then( res => {
                    resolve( res );
                })
                .catch( err => {
                    reject( err );
                })
        }));
    }
}